import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(1),
  },
  shortcutHint: {
    marginLeft: theme.spacing(2),
  },
}));

interface ViewModeToggleProps {
  viewMode: 'form' | 'pdf';
  onViewModeChange: (mode: 'form' | 'pdf') => void;
  pdfAvailable: boolean;
}

/**
 * Component for toggling between form and PDF views
 */
const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  onViewModeChange,
  pdfAvailable,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Button
        variant={viewMode === 'form' ? 'contained' : 'outlined'}
        color="primary"
        startIcon={<EditIcon />}
        onClick={() => onViewModeChange('form')}
        className={classes.button}
      >
        Edit Form
      </Button>
      <Button
        variant={viewMode === 'pdf' ? 'contained' : 'outlined'}
        color="primary"
        startIcon={<VisibilityIcon />}
        onClick={() => onViewModeChange('pdf')}
        disabled={!pdfAvailable}
      >
        View Original PDF
      </Button>
      <Typography variant="caption" className={classes.shortcutHint}>
        Tip: Press Ctrl+B to toggle between views
      </Typography>
    </Box>
  );
};

export default ViewModeToggle;
